import { useEffect } from 'react'
import type { ImageInfo } from '@/components/online_clinic/examinations/InterviewContent'

type Props = {
  image: ImageInfo | null
  onClose: () => void
}

export default function ImageLightbox({ image, onClose }: Props) {
  useEffect(() => {
    if (!image) return
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleEsc)
    document.body.style.overflow = 'hidden'
    return () => {
      window.removeEventListener('keydown', handleEsc)
      document.body.style.overflow = ''
    }
  }, [image, onClose])

  if (!image) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="relative max-w-[700px] w-full max-h-[90vh] bg-white rounded-lg overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          onClick={onClose}
          aria-label="閉じる"
          className="absolute top-2 right-2 z-10 bg-white/90 rounded-full w-8 h-8 flex items-center justify-center text-[#2a3039] text-xl leading-none border border-gray-200"
        >
          ×
        </button>
        {image.is_pdf ? (
          <object data={image.url} type="application/pdf" className="w-full h-[80vh]">
            <p className="p-4">
              PDFを表示できません。
              <a href={image.url} target="_blank" rel="noopener noreferrer" className="text-[#2196f3] underline ml-1">
                新しいタブで開く
              </a>
            </p>
          </object>
        ) : (
          <img src={image.url} alt="" className="w-full h-auto max-h-[90vh] object-contain" />
        )}
      </div>
    </div>
  )
}
